import { render, staticRenderFns } from "./ProformaTerm.vue?vue&type=template&id=2344580c&scoped=true&"
import script from "./ProformaTerm.vue?vue&type=script&lang=js&"
export * from "./ProformaTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344580c",
  null
  
)

export default component.exports